import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  heading: {
    id: 'views.ZszPolicy.heading',
    defaultMessage: 'ISO 27001 i 9001 w grupie kapitałowej TenderHut'
  }
});



// WEBPACK FOOTER //
// ./src/views/ZszPolicy/ZszPolicyView.intl.js